import { render, staticRenderFns } from "./InsightsOverview.vue?vue&type=template&id=23735c52"
import script from "./InsightsOverview.vue?vue&type=script&lang=js"
export * from "./InsightsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports